"use client";

import { useRouter } from "next/navigation";
import { useCallback } from "react";
import { toastError } from "../../logging/logger";
import { useUser } from "../../providers/user-provider";

const ALLOWED_EXTERNAL_REDIRECT_DOMAINS = [
  "groq.com",
  "groqcloud.net",
  "community.groq.com",
];

export const usePostAuthRedirect = (defaultReturnTo: string) => {
  const router = useRouter();
  const { setOrgIdFromJWT } = useUser();

  const redirectAfterLogin = useCallback(() => {
    setOrgIdFromJWT();

    const returnTo = localStorage.getItem("returnTo");
    if (returnTo && returnTo !== "/login" && returnTo !== "/") {
      localStorage.removeItem("returnTo");

      if (returnTo.startsWith("http://") || returnTo.startsWith("https://")) {
        const returnToUrl = new URL(returnTo);
        if (ALLOWED_EXTERNAL_REDIRECT_DOMAINS.includes(returnToUrl.hostname)) {
          window.location.href = returnTo;
        } else {
          toastError(
            "Invalid Redirect",
            new Error(
              // Make it obvious that the returnToUrl.hostname is user provided
              // so malicious URLs can't sneak in messages pretending to be us.
              `Refused to redirect to host ${JSON.stringify(returnToUrl.hostname)}. Sending you to the fallback page.`,
            ),
          );
          router.push(defaultReturnTo);
        }
      } else {
        router.push(returnTo);
      }
    } else {
      router.push(defaultReturnTo);
    }
  }, [router, defaultReturnTo]);

  return { redirectAfterLogin };
};
